import mixitup from 'mixitup';
export var initFilters = function initFilters() {
  var fillters = document.querySelector('.filtered-posts');

  if (!fillters) {
    return;
  }

  var mixer = mixitup('.filtered-posts', {
    //   multifilter: {
    //     enable: true
    // },
    animation: {
      "duration": 650,
      "nudge": true,
      "reverseOut": false,
      "effects": "fade"
    } // load: {
    //   filter: firstCategory,
    // },

  });
}; // 370 // wysokość 47,8 %